export interface WorldRegion {
  id: number;
  name: string;
  code: string[];
}

export const WORLD_REGIONS: WorldRegion[] = [
  { id: 4667, name: 'benelux', code: ['be', 'nl', 'lu'] },
  { id: 4660, name: 'canada', code: ['ca'] },
  { id: 20, name: 'china', code: ['cn'] },
  { id: 4657, name: 'france', code: ['fr'] },
  { id: 4666, name: 'germany', code: ['de'] },
  { id: 4663, name: 'japan', code: ['jp'] },
  { id: 4662, name: 'latin-america', code: ['ar', 'bo', 'br', 'cl', 'co', 'cr', 'cu', 'do', 'ec', 'sv', 'gt', 'hn', 'mx', 'ni', 'pa', 'py', 'pe', 'uy', 've'] },
  { id: 4668, name: 'nordics', code: ['dk', 'fi', 'is', 'no', 'se', 'gl', 'fo', 'ax'] },
  { id: 4661, name: 'oceania', code: ['au', 'fj', 'ki', 'mh', 'fm', 'nr', 'nz', 'pw', 'pg', 'ws', 'sb', 'to', 'tv', 'vu'] },
  { id: 7392, name: 'poland', code: ['pl'] },
  { id: 4664, name: 'spain', code: ['es'] },
  { id: 4658, name: 'uk', code: ['gb'] },
  { id: 4659, name: 'usa', code: ['us'] },
  { id: 19, name: 'vietnam', code: ['vn'] },
];